export default "__VITE_PUBLIC_ASSET__fd0abdf6__"